import type { TDatadogErrorLog } from 'utils/datadog/types'

export const ME_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/hooks/use-me',
  name: 'me_query_failed',
  message: 'Failed to fetch the authenticated user',
}

// Users whose email is on this domain are Winnin's own staff; everyone else triggers the
// `notWinninUserIsAuthenticated` GTM event (downstream Intercom/Hubspot segmentation).
export const WINNIN_EMAIL_DOMAIN = '@winnin.com'

// A StatusMessage is a *successful* `me` response, so `buildQueryHook`'s errorLog never catches it.
// We log it explicitly to keep an auth-bootstrap failure observable in Datadog.
export const STATUS_MESSAGE_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/hooks/use-me',
  name: 'me_status_message',
  message: 'The me query resolved a StatusMessage instead of a User',
}
